/*eslint-disable */

import EmojiPicker from 'vue-emoji-picker'
import axios from 'axios';
import { bus } from '@/main';
import commonSocketConnectMethod from "@/commonSocket";
import { mapGetters } from 'vuex';
import moment from 'moment';
import responsiveMixin from '@/mixins/responsive';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

// Lazy load components
const suggestionUserListForChat = () => import('@/components/private/workspace/chat-for-user-suggestion-list/');
const pinnedChatRoom = () => import('@/components/private/workspace/chat-room-pinned-popup/');
const percentageLoader = () => import('@/components/common/percentage-loader-f-file/');
const msgDeletePopup = () => import('@/components/private/workspace/msg-delete-popup/');
const messageSearchPopup = () => import('@/components/private/workspace/message-search-popup/');
const forwardMsgPopup = () => import('@/components/private/workspace/forward-msg-popup/');
const groupInfoPopup = () => import('@/components/private/workspace/group-info-preview-popup');

let UploadMsgFileURL = root.uploadMsgFileUrl.link;
var pingInterval;
const $ = window.jQuery = require('jquery');
export default {
  name: 'chat-info-section',
  mixins: [responsiveMixin],
  components: {
    'msg-delete-popup': msgDeletePopup,
    'pinned-room-popup': pinnedChatRoom,
    forwardMsgPopup,
    'suggestion-user-list': suggestionUserListForChat,
    'message-search-popup': messageSearchPopup,
    percentageLoader,
    EmojiPicker,
    'group-info-popup': groupInfoPopup
  },
  props: ['selectedChatRoomData', 'welcomeBlurbState'],
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  data() {
    return {
      selectedRoomInfo: null,
      message: '',
      submitted: false,
      selfUserInfo: null,
      chatSocketMethod: null,
      listLoading: false,
      blockedUserId: '',
      blockedUserEmail: '',
      uploadFile: null,
      filename: '',
      imgSrc: '',
      fileMessage: '',
      blockSelectUser: false,
      msgNextPageLoader: '',
      selectedActvRoomId: '',
      chatAllListResults: [],
      msgApiLoader: false,
      msgValue: '',
      groupInfoState: false,
      someInfoOfGroupState: null,
      selfUserId: localStorage.getItem('LoginedUserID'),
      selection_type: 'press_enter',
      messageFeatureStates: false,
      deleteMessageDataObj: {
        id: '',
        text: '',
        time: '',
        createdBy: '',
        roomId:'',
      },
      deleteMsgPopupState: false,
      replyMsgDataObj: {
        data: ''
      },
      replyMsgAlertState: false,
      messageIdForReply: '',
      pinnedRoomPopupState: false,
      pinnedRoomId: '',
      pinnedRoomStatus: '',
      selectedRoomOfChatUpperInfo: {
        pinned: Boolean,
        chat_room: ''
      },
      forwardMsgPopup: false,
      suggestionUserListState: false,
      suggestionUserListData: {
        handle: ''
      },
      messageContentDraftValue: '',
      suggestionUserListStateForFileAttach: false,
      individualActivityTrackerState: false,
      typingUserInfoState: '',
      messageListResultsDto: null,
      welcomeBlurbsPopupState: false,
      messageSearchPopupState: false,
      multipleMessageArr: [],
      multiMessageOptionEnabled: false,
      uploadProgress: 0,
      search: '',
      emojis: ["👍", "👎", "😭", "😕", "😐", "😊", "😍",],
      typingTimeout: null,
      lastLiveMsgData:null
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfo() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
      return;
    },
    getSelectedChatRoomInfo() {
      return this.selectedChatRoomData;
    },
    welcomeBlurbInfo() {
      return this.welcomeBlurbState;
    },
    reversedChatListResults() {
      return [...this.chatAllListResults].reverse();
    },
  },
  mounted() {
    if (this.selectedChatRoomData) {
      this.selectedRoomInfo = this.selectedChatRoomData;
      this.buildChatRoomMethod(this.selectedChatRoomData);
    }
    if (this.welcomeBlurbState) {
      this.welcomeBlurbsPopupState = true;
    }

    // Router Leave Of The Workspace Event Listener
    bus.$on('workspaceRouterLeaveEvntBus', (data) => {
      if (data == "Router_leave") {
        this.chatWebSocketClosedFroceMethod();
      }
    })

    // Typing For Selected User Event Listener
    bus.$on('typingEventForChatBus', (data) => {
      this.typingUserInfoState = data;
      if (data.message == 'stop') {
        this.typingUserInfoState = '';
      }
    })
    // Assuming 'bus' is an existing event bus or custom event dispatcher
    bus.$on('MessageDeleteForChatOfAllNotification', (data) => {
        const chatMessageElement = document.getElementById('chatMessageId' + data.id);
        if (chatMessageElement) {
            const dropdown = chatMessageElement.querySelector('.dropdown');
            if(dropdown){
            dropdown.remove();
            }
            const replyWrapper = chatMessageElement.querySelector('.show_msg_of_reply_wrp');
            if(replyWrapper){
            replyWrapper.remove();
            }
            const label = chatMessageElement.querySelector('label');
            if(label){
            label.remove();
            }
            const sender = chatMessageElement.querySelector('.message_sender_name');
            if(sender){
              sender.remove();
            }
            const chatMsgBoxWrp = chatMessageElement.querySelector('.chat_in_msg_box_wrp');
            if(chatMsgBoxWrp){
            chatMsgBoxWrp.classList.add('delete_msg_show_box');
            const msgInFile = chatMessageElement.querySelector('.msg_in_file');
            if(msgInFile){
                msgInFile.style.color = "#4c4c4c";
                msgInFile.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
            }else{
                const anchorTag = chatMsgBoxWrp.querySelector('span');
                anchorTag.style.color = "#4c4c4c";
                anchorTag.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
            }
            }
        }
    });
    
    bus.$on('updateGroupInfoDataBus', (data) => {
      this.selectedRoomInfo = data;
    })
    bus.$on('groupInfoStateBus', (data) => {
      this.groupInfoState = data;
    })
    
    bus.$on('updateCurrentUserChatUpperInfoDataBus', (data) => {
      this.selectedRoomOfChatUpperInfo.pinned = data.pinned;
      this.selectedRoomOfChatUpperInfo.chat_room = data.chat_room;
    })
    // Enter Loader Hide Code Here
    var _self = this
    $('#chat_msg_list_scroll').on("scroll", function () {
      var yScrollHeight;
      var elmntList = document.getElementById("chat_msg_list_scroll");
      yScrollHeight = elmntList.scrollHeight;
      if (0 == $('#chat_msg_list_scroll').scrollTop()) {
        if (_self.msgNextPageLoader) {
          _self.msgApiLoader = true;
          axios.get(_self.msgNextPageLoader).then((response) => {
            _self.msgNextPageLoader = '';
            if (response.status == '200') {
              _self.msgNextPageLoader = response.data.data.next;
              _self.msgApiLoader = false;
              _self.chatAllListResults = [].concat(_self.chatAllListResults, response.data.data.results);
              setTimeout(() => {
                let recentScrlHeight = elmntList.scrollHeight;
                elmntList.scrollTop = recentScrlHeight - yScrollHeight;
              }, 10)
            }
          }).catch((err) => { })
        }
      }
    });
    bus.$on('deleteMsgPopupStateBus', (data) => {
      this.deleteMsgPopupState = data;
    })
    bus.$on('pinnedRoomPopupStateBus', (data) => {
      this.pinnedRoomPopupState = data;
    })
    bus.$on('forwardMsgPopupBus', (data) => {
      $('.live_msg_f_label').removeClass('d-block');
      $('.chat_msg_li').removeClass('selected');
      $('.live_msg').removeClass('selected');
      this.forwardMsgPopup = data;
      this.multiMessageOptionEnabled = false;
      this.multipleMessageArr = [];
    })
    bus.$on('suggestionUserListStateBus', (data) => {
      this.suggestionUserListState = data;
      let valueSpilt = this.messageContentDraftValue.split('@');
      if (valueSpilt.length == 2) {
        this.messageContentDraftValue = valueSpilt[0] + '@' + this.suggestionUserListData.handle;
      } else if (valueSpilt.length == 3) {
        this.messageContentDraftValue = valueSpilt[0] + '@' + valueSpilt[1] + '@' + this.suggestionUserListData.handle;
      } else if (valueSpilt.length == 4) {
        this.messageContentDraftValue = valueSpilt[0] + '@' + valueSpilt[1] + '@' + valueSpilt[2] + '@' + this.suggestionUserListData.handle;
      }
      $('#chat-message-reply-input').focus();
    })
    bus.$on('suggestionUserListStateForFileAttachBus', (data) => {
      this.suggestionUserListStateForFileAttach = data;
      this.userNameMentionDataForAttachment();
    })
    bus.$on('individualActivityTrackerStateBus', (data) => {
      this.individualActivityTrackerState = data;
    })
    bus.$on('messageSearchPopupStateBus', (data) => {
      this.messageSearchPopupState = data;
    })
  },
  methods: {  
    isImageFile(filePath) {
      const imageExtensions = ['png', 'jpeg', 'jpg', 'svg', 'gif', 'webp'];
      const fileExtension = filePath.split('.').pop().toLowerCase();
      let extension = fileExtension.substring(0, fileExtension.lastIndexOf("?"));
      return imageExtensions.includes(extension);
    },
    getFileName(filePath) {
      return filePath.split('/').pop().split('?')[0];
    },
    chatWebSocketClosedFroceMethod() {
      if (this.chatSocketMethod) {
        this.chatSocketMethod.close();
      }
    },
    hideMenuBarOnMblMethod() {
      this.chatWebSocketClosedFroceMethod();
      this.selectedActvRoomId = '';
      // Get the element with id 'sidepanel'
      const sidepanel = document.getElementById('sidepanel');
      if (sidepanel) {
        sidepanel.classList.remove('d-none');
      }

      // Get the element with id 'chatContentWrp'
      const chatContentWrp = document.getElementById('chatContentWrp');
      if (chatContentWrp) {
        chatContentWrp.classList.remove('d-block');
      }
      document.querySelectorAll('.chat_user_listed').forEach((element) => {
          element.classList.remove('active');
      });
      // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
      if ($ && typeof $.fn.remove === 'function') {
        $('.live_msg').remove();
      } else {
      // console.warn("jQuery not available or .remove() not a function. Cannot remove '.live_msg' elements.");
        document.querySelectorAll('.live_msg').forEach(el => el.remove());
      }
      bus.$emit('hideChatSectionInMblBus', true);
    },
    getMessageStatusMethod(messageStatus) {
      if (!messageStatus) return;
      const allRead = messageStatus.every(status => status.is_read);
      const allDelivered = messageStatus.every(status => status.is_delivered);
      if (allRead) {
        return 'read';
      } else if (allDelivered) {
        return 'delivered';
      } else {
        return 'undelivered';
      }
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    },

    formatDateSeparator(timestamp) {
      const date = new Date(timestamp);
      const options = { month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
    insertEmojiMethod(emoji) {
      this.messageContentDraftValue += emoji
    },
    /*
    * Message Search Popup For Method Here
    */
    messageSearchPopupEnableMethod() {
      this.messageSearchPopupState = true;
    },
    /*
    * This Will Check Blocked User Method Here
    */
    blockedUserMethod(id, first_name, last_name) {
      this.blockedUserId = id;
      this.blockedUserEmail = first_name + ' ' + last_name;
      this.blockSelectUser = true;
    },
    confirmBlockedUser() {
      let data = {
        blocked_user: this.blockedUserId
      }
      this.listLoading = true;
      this.$store.dispatch('createBlockUserFun', data)
        .then((res) => {
          this.$store.dispatch('getAllLeftChatListDetailsFun');
          toast.success(res.data.msg);
          this.listLoading = false;
          this.noConfirmBlockedUser();
        }).catch((error) => {
          toast.error(error.data.data.non_field_errors || error.data.msg);
          this.listLoading = false;
        })
    },
    noConfirmBlockedUser() {
      this.blockedUserId = '';
      this.blockedUserEmail = '';
      this.blockSelectUser = false;
    },
    /*
     * This Will Check Blocked User Method Here End
     */
    selectedOptionMethod(item) {
      this.selection_type = item;
      this.messageFeatureStates = false;
    },
    messageFeatureStatesMethod() {
      if (this.messageFeatureStates) {
        this.messageFeatureStates = false;
      } else {
        this.messageFeatureStates = true;
        var _self = this
        $(document).click(function (event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".option_btn_wrp").length) {
            _self.messageFeatureStates = false
          }
        });
      }
    },
    groupSomeInfoEnabled(data) {
      this.someInfoOfGroupState = data,
      this.groupInfoState = true;
    },
    /*
     * This Methods Code Start For Chat Room Specific
     */
    enabledYearDateFun(msgDateTime) {
      var currentLocalDate = moment().format('YYYY');
      var startDateCheck = moment(msgDateTime).format('YYYY');
      if (currentLocalDate > startDateCheck) {
        return true;
      } else {
        return false;
      }
    },
    newline() { },
    send() { },
    checkTheColorFun(allUser, sender) {
      for (var i = 0; i < allUser.length; i++) {
        if (allUser[i].user.id == sender.user_id) {
          return allUser[i].colour;
        }
      }
    },
    /*
     * This Methods Code End For Chat Room Specific
     */
    getURLObj() {
      return window.URL || window.webkitURL;
    },
    captureImgOnPasteMethod(e) {
      if (e.clipboardData && e.clipboardData.items) {
        var items = e.clipboardData.items;
        for (var i = 0; i < items.length; i++) {
          if (items[i].type.indexOf('image') !== -1) {
            var blob = items[i].getAsFile();
            var URLObj = this.getURLObj();
            var source = URLObj.createObjectURL(blob);
            this.uploadFile = blob;
            this.imgSrc = source;
            this.filename = 'Photo';
            e.preventDefault();
          }
        }
      }
    },
    userNameMentionDataForAttachment() {
      let valueSpilt = this.fileMessage.split('@')
      if (valueSpilt.length == 2) {
        this.fileMessage = valueSpilt[0] + '@' + this.suggestionUserListData.handle;
      } else if (valueSpilt.length == 3) {
        this.fileMessage = valueSpilt[0] + '@' + valueSpilt[1] + '@' + this.suggestionUserListData.handle;
      } else if (valueSpilt.length == 4) {
        this.fileMessage = valueSpilt[0] + '@' + valueSpilt[1] + '@' + valueSpilt[2] + '@' + this.suggestionUserListData.handle;
      }
    },
    suggestionListPopupClosed() {
      this.suggestionUserListStateForFileAttach = false;
      this.suggestionUserListState = false;
      this.suggestionUserListData.handle = '';
    },
    getStatusTimeOfMinMethod(sc) {
      var cth = moment().format('HH');
      var ctm = moment().format('mm:ss');
      var sth = moment(sc).format('HH');
      var stm = moment(sc).format('mm:ss');
      var cft = cth * parseInt(60) + parseInt(ctm);
      var sft = sth * parseInt(60) + parseInt(stm);
      var nt = cft - sft;
      return nt;
    },
    urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return text.replace(urlRegex, function (url, b, c) {
        var url2 = (c == 'www.') ? 'http://' + url : url;
        return '<a href="' + url2 + '" target="_blank" class="hyper_link">' + url + '</a>';
      })
    },
    forwardMsgCheckboxMethod(message, id) {
      let e = document.getElementById('msg_input' + id).parentNode;
      let $label = e.parentNode;
      if (document.getElementById('msg_input' + id).checked == false) {
        this.removeObjectWithIdFromForwardMessageMethod(id);
      } else {
        this.multipleMessageArr.push(message);
      }
      if ($label.classList.contains("selected")) {
        $label.classList.remove("selected");
      } else {
        $label.classList.add("selected");
      }
    },
    removeObjectWithIdFromForwardMessageMethod(id) {
      const objWithIdIndex = this.multipleMessageArr.findIndex((obj) => obj.chat_data.message_id === id);
      if (objWithIdIndex > -1) {
        this.multipleMessageArr.splice(objWithIdIndex, 1);
      }
      return this.multipleMessageArr;
    },
    onchangeOfMsgFrwdMethod(id) {
      let e = document.getElementById('msg_input' + id).parentNode
      let $label = e.parentNode
      if ($label.classList.contains("selected")) {
        $label.classList.remove("selected");
      } else {
        $label.classList.add("selected");
      }
    },
    forwardLiveMsgToUserMethod(item) {
      $('.live_msg_f_label').addClass('d-block');
      this.multipleMessageArr.push(item);
      document.getElementById('msg_input' + item.id).checked = true;
      this.multiMessageOptionEnabled = true;
      let messageInputDom = document.querySelector('#chat-message-reply-input');
      messageInputDom.value = '';
      this.messageContentDraftValue = '';
      setTimeout(() => {
        this.onchangeOfMsgFrwdMethod(item.id);
      }, 100)
    },
    forwardMsgToUserMethod(item) {
      $('.live_msg_f_label').addClass('d-block');
      this.multipleMessageArr.push(item);
      this.multiMessageOptionEnabled = true;
      let messageInputDom = document.querySelector('#chat-message-reply-input');
      messageInputDom.value = '';
      this.messageContentDraftValue = '';
      setTimeout(() => {
        this.onchangeOfMsgFrwdMethod(item.id);
      }, 100)
    },
    clearMultipleMsgDataMethod() {
      $('.live_msg_f_label').removeClass('d-block');
      $('.chat_msg_li').removeClass('selected');
      $('.live_msg').removeClass('selected');
      this.multiMessageOptionEnabled = false;
      this.multipleMessageArr = [];
    },
    forwardMultipleMsgToUserMethod() {
      this.forwardMsgPopup = true;
    },
    /*
     * This Will Chat Room Pinned
    */
    pinnedChatRoomMethod(chatRoomStatus, chatRoomId) {
      this.pinnedRoomStatus = chatRoomStatus;
      this.pinnedRoomId = chatRoomId;
      this.pinnedRoomPopupState = true;
    },
    /*
     * This Will Reply Selected Message From Chat
    */
    replyMessageOnChatMethod(msgData) {
      this.replyMsgDataObj.data = msgData;
      this.replyMsgAlertState = true;
      this.messageIdForReply = msgData.id;
      document.getElementById("chat-message-reply-input").focus();
    },

    cancelReplyMessageOnChatMethod() {
      this.messageIdForReply = '';
      this.replyMsgDataObj.data = '';
      this.replyMsgAlertState = false;
    },
    /*
     * This Will Delete Selected Message From Chat
    */
    deteteMessageFromChatMethod(messageId, MsgText, messageTime, createdBy) {
      this.deleteMessageDataObj.id = messageId;
      this.deleteMessageDataObj.time = messageTime;
      this.deleteMessageDataObj.text = MsgText;
      this.deleteMessageDataObj.createdBy = createdBy;
      this.deleteMessageDataObj.roomId = this.selectedRoomInfo.chat_room;
      this.deleteMsgPopupState = true;
    },
    /*
     * This Will Scroll Bottom Of ChatBox
    */
    chatScrollBottomMethod() {
      var elmnt = document.getElementById("chat_msg_list_scroll");

      if (!elmnt) {
        console.warn("Element with ID 'chat_msg_list_scroll' not found.");
        return;
      }

      var scrollHeight = elmnt.scrollHeight;
      var clientHeight = elmnt.clientHeight;
      var scrollTop = elmnt.scrollTop;
      var distanceFromBottom = scrollHeight - (clientHeight + scrollTop);
      var scrollHeightTotal = (distanceFromBottom + clientHeight + scrollTop);
      elmnt.scrollTop = scrollHeightTotal;
    },
    /*
     * This Will Checking Chat Message Position 
    */
    getMessageTypeMethod(chatData) {
      if (!chatData) return;
      if (chatData.sender) {
        if (chatData.sender.user_id == this.selfUserId) {
          return 'recieved';
        } else {
          return 'sent';
        }
      }
    },
    /*
     * this will check the new message notification
    */
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },

    /*
     * this will get All Message List again
    */
    allMessageListMethod() {
      this.$store.dispatch('getUserChatDetailsByIdFun', {
          id: this.selectedRoomInfo.chat_room
        }).then((response) => {
          this.messageListResultsDto = response.data.data;
          this.chatAllListResults = [].concat(response.data.data.results);
          this.msgNextPageLoader = response.data.data.next;
          // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
          if ($ && typeof $.fn.remove === 'function') {
            $('.live_msg').remove();
          } else {
            // console.warn("jQuery not available or .remove() not a function. Cannot remove '.live_msg' elements.");
            document.querySelectorAll('.live_msg').forEach(el => el.remove());
          }
          this.lastLiveMsgData = null; // Reset lastLiveMsgData to null
        })
    },
    /*
     * This Will Opned Chat Room With Selected user Of Contact List Method Here
     */
    buildChatRoomMethod(chatRoomInfo) {
      const token = localStorage.getItem('token');
      this.selectedRoomInfo = chatRoomInfo;
      const roomId = chatRoomInfo.chat_room;
      const userRoomPinnedState = chatRoomInfo.pinned;

      // Reset UI states immediately
      this.lastLiveMsgData = null;
      this.messageContentDraftValue = '';
      this.suggestionUserListState = false;
      this.cancelReplyMessageOnChatMethod();
      this.someInfoOfGroupState = null;
      this.groupInfoState = false;

      // Only proceed with room-specific actions if the room has truly changed
      if (this.selectedActvRoomId !== roomId) {

        // 1. --- IMPORTANT: Close existing WebSocket connection before opening a new one ---
        if (this.chatSocketMethod && this.chatSocketMethod.readyState === WebSocket.OPEN) {
          this.chatSocketMethod.close();
          this.chatSocketMethod = null; // Clear the reference
        }

        // Also clear any pending typing timeout from the previous room
        if (this.typingTimeout) {
          clearTimeout(this.typingTimeout);
          this.typingTimeout = null;
        }

        this.selectedActvRoomId = roomId;
        this.msgNextPageLoader = '';
        this.selectedRoomOfChatUpperInfo.pinned = userRoomPinnedState;
        this.selectedRoomOfChatUpperInfo.chat_room = chatRoomInfo.chat_room;
        this.messageListResultsDto = null;
        this.chatAllListResults = [];

        // Remove old live messages (consider Vue's reactivity more, but fallback is fine)
        if ($ && typeof $.fn.remove === 'function') {
          $('.live_msg').remove();
        } else {
          // console.warn("jQuery not available or .remove() not a function. Cannot remove '.live_msg' elements.");
          document.querySelectorAll('.live_msg').forEach(el => el.remove());
        }

        const chatRoomSocketId = chatRoomInfo.chat_room.replace(/-/g, "");

        this.$store.dispatch('getUserChatDetailsByIdFun', {
          id: chatRoomInfo.chat_room
        }).then((response) => {
          this.messageListResultsDto = response.data.data;
          this.chatAllListResults = [].concat(response.data.data.results);
          this.msgNextPageLoader = response.data.data.next;
          bus.$emit('unreadCountClearedForUserBus', true);

          this.$nextTick(() => { 
            this.chatScrollBottomMethod();
            const messageInputDom = document.querySelector('#chat-message-reply-input');
            const messageSubmitDom = document.querySelector('#chat-message-reply-submit');

            if (messageInputDom) {
              // Remove previous listeners to prevent duplicates
              if (this._keydownListener) {
                messageInputDom.removeEventListener('keydown', this._keydownListener);
              }
              if (this._keyupListener) {
                messageInputDom.removeEventListener('keyup', this._keyupListener);
              }

              // Attach new listeners (using arrow functions to preserve 'this')
              this._keydownListener = (event) => {
                if (event.key === 'PageUp' || event.key === 'PageDown') {
                  const cursorPosition = event.key === 'PageUp' ? 0 : event.target.textLength;
                  event.preventDefault();
                  event.target.setSelectionRange(cursorPosition, cursorPosition);
                }
              };
              messageInputDom.addEventListener('keydown', this._keydownListener);

              // Declare typingTimeout as a component property
              this._keyupListener = (event) => {
                this.msgValue = messageInputDom.value;
                this.messageContentDraftValue = messageInputDom.value; // Keep this consistent

                if (this.messageContentDraftValue.length >= 1) {
                  if (this.messageContentDraftValue.slice(-1) === '@' || event.key === '@') {
                    this.suggestionUserListState = true;
                  }
                } else {
                  this.suggestionUserListState = false;
                }

                if (this.selection_type === 'press_enter') {
                  if (event.keyCode === 13) {
                    if (event.shiftKey) {
                      event.stopPropagation();
                    } else if (!event.shiftKey) {
                      event.preventDefault();
                      if (messageSubmitDom) {
                        messageSubmitDom.click();
                      }
                    }
                  } else {
                    if (messageInputDom.value.length > 0) {
                      commonSocketConnectMethod.emit({
                        type: "TypingEventForChat",
                        message: 'typing',
                        ChatRoomId: chatRoomInfo.chat_room
                      });
                      clearTimeout(this.typingTimeout); // Clear previous timeout using component property
                      this.typingTimeout = setTimeout(() => { // Assign to component property
                        commonSocketConnectMethod.emit({
                          type: "TypingEventForChat",
                          message: 'stop',
                          ChatRoomId: chatRoomInfo.chat_room
                        });
                      }, 2000);
                    }
                  }
                }
              };
              messageInputDom.addEventListener('keyup', this._keyupListener);

              messageInputDom.focus();
            }

            if (messageSubmitDom) {
              // Remove previous listeners to prevent duplicates
              if (this._submitClickListener) {
                messageSubmitDom.removeEventListener('click', this._submitClickListener);
              }

              this._submitClickListener = (e) => {
                const messageInputDom = document.querySelector('#chat-message-reply-input');
                this.msgValue = messageInputDom ? messageInputDom.value : '';
                const message = this.msgValue;
                const msg = message.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();

                if (msg !== "") {
                  const payload = {
                    chatRoomId: chatRoomInfo.chat_room,
                    message: message,
                    senderName: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
                  };

                  // Ensure typing 'stop' is sent and timeout cleared before sending message
                  commonSocketConnectMethod.emit({
                    type: "TypingEventForChat",
                    message: 'stop',
                    ChatRoomId: chatRoomInfo.chat_room
                  });
                  clearTimeout(this.typingTimeout); // Clear any pending typing timeout

                  // Ensure chatSocketMethod is initialized and open before sending
                  if (this.chatSocketMethod && this.chatSocketMethod.readyState === WebSocket.OPEN) {
                    if (this.messageIdForReply) {
                      this.chatSocketMethod.send(JSON.stringify({
                        type: 'chat_message',
                        message: {
                          content: message,
                          reply_to: this.messageIdForReply,
                        }
                      }));
                    } else {
                      this.chatSocketMethod.send(JSON.stringify({
                        type: 'chat_message',
                        message: {
                          content: message,
                        }
                      }));
                    }
                  } else {
                    // console.warn("Chat WebSocket not open or not initialized. Message not sent.", this.chatSocketMethod);
                    // Potentially queue message or show user a warning
                  }

                  bus.$emit('newChatMessage', payload);
                  if (!userRoomPinnedState) {
                    bus.$emit('selfFullChatListOrdChangedBus', chatRoomInfo.chat_room);
                  }

                  if (messageInputDom) {
                    messageInputDom.value = '';
                  }
                  this.msgValue = '';
                  this.messageContentDraftValue = '';
                  this.cancelReplyMessageOnChatMethod();
                }
              };
              messageSubmitDom.addEventListener('click', this._submitClickListener);
            }
          });
          this.WebSocketConnectionMethod(chatRoomSocketId, token); // Call WebSocket connection method
        });
      }
    },

    WebSocketConnectionMethod(chatRoomSocketId, token) {

      this.chatSocketMethod = new WebSocket(
        'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
        '/ws/chat/' + chatRoomSocketId + '/?token=' + token
      );

      this.chatSocketMethod.onopen = () => {
        // console.log('Chat WebSocket opened for room:', chatRoomSocketId);
        pingInterval = setInterval(() => {
          if (this.chatSocketMethod.readyState === WebSocket.OPEN) {
            this.chatSocketMethod.send(JSON.stringify({ type: 'ping' })); // Send a ping message
          }
        }, 30000); 
      };

      this.chatSocketMethod.onmessage = (e) => {
        this.renderLiveMessageMethod(e);
      };

      this.chatSocketMethod.onclose = (e) => {
        // console.error("WebSocket Close");
        clearInterval(pingInterval);
        this.chatSocketMethod = null;
      };
      
      this.chatSocketMethod.onerror = (error) => {
        clearInterval(pingInterval);
        this.chatSocketMethod = null;
      };
    },

    renderLiveMessageMethod(e) {
      const data = JSON.parse(e.data);
      if(data.type == 'pong') {
       return;
      }else if(data.type == 'readStatus') {
        if(this.lastLiveMsgData){
          this.allMessageListMethod();
       }
       return;
      }else{  
        const messagesList = document.getElementById('reply_msg_list');
        this.displayChatMessageMethod(data.message, messagesList);
      }
    },

    displayChatMessageMethod(data, messagesList) {
      const selfUserId = this.selfUserId; // Assuming 'this' context is correct
      const isSelf = data.sender.user_id === selfUserId;
      
      if(data.delete_for_everyone){
          if (!isSelf) {
          bus.$emit('MessageDeleteForChatOfAllNotification', data);
          }
        return;
      };
      const isGroup = this.selectedRoomInfo.is_group_chat;
      const message = data.message;
      const messageElement = document.createElement('div');
      messageElement.classList.add('live_msg');
      messageElement.id = `chatMessageId${data.id}`;

      const messageContentWrapper = document.createElement('div');
      messageContentWrapper.classList.add(data.sender.user_id === selfUserId ? 'recieved' : 'sent');
      messageElement.appendChild(messageContentWrapper);

      const chatMessageBox = document.createElement('div');
      chatMessageBox.classList.add('chat_in_msg_box_wrp');
      messageContentWrapper.appendChild(chatMessageBox);


      // Add SenderName Label if applicable
      if (!isSelf && isGroup) {
        chatMessageBox.appendChild(this.createSenderName(data));
      }

      // Add Forwarded Label if applicable
      if (data.forwarded) {
        chatMessageBox.appendChild(this.createForwardedLabelMethod());
      }

      // Add Reply Feature if applicable
      if (data.reply_to_msg) {
        chatMessageBox.appendChild(this.createReplyInfoMethod(data)); // Assuming 'message' is accessible here
      }

      // Add Message Content (File, Link, or Text)
      chatMessageBox.appendChild(this.createMessageContentMethod(data));

      // Add Dropdown for Options
      chatMessageBox.appendChild(this.createMessageOptionsDropdownMethod(data, this)); // Passing 'this' for context

      // Add Timestamp and Read Status
      const timeWrapper = document.createElement('span');
      timeWrapper.classList.add('msg_time_wrp');
      const timeElement = document.createElement('time');
      timeElement.classList.add('msg_time');
      timeElement.textContent = moment(data.timestamp).locale('en').format('h:mm a');
      timeWrapper.appendChild(timeElement);
      chatMessageBox.appendChild(timeWrapper);

      if (data.sender.user_id === selfUserId) {
        timeElement.after(this.createReadStatusLabelMethod(data));
      }

      // Add Forward Multiple Checkbox
      messageElement.appendChild(this.createForwardCheckboxMethod(data, message, this));
      messagesList.appendChild(messageElement);
      this.chatScrollBottomMethod();
    },

    createSenderName(chatData) {
      const senderName = document.createElement("span");
      senderName.className = 'message_sender_name';
      senderName.style.color = chatData.sender.colour;
      senderName.textContent = chatData.sender.first_name + ' ' + chatData.sender.last_name;
      return senderName;
    },

    createForwardedLabelMethod() {
      const forwardedMsgText = document.createElement("span");
      forwardedMsgText.classList.add('forwarded_msg_text');
      const shareIcon = document.createElement("i");
      shareIcon.classList.add('fa', 'fa-share');
      const forwardedMsgContent = document.createElement("span");
      forwardedMsgContent.textContent = 'Forwarded';
      forwardedMsgText.appendChild(shareIcon);
      shareIcon.after(forwardedMsgContent);
      return forwardedMsgText;
    },

    createReplyInfoMethod(replyData) {
      const showMsgOfReplyWrp = document.createElement("span");
      showMsgOfReplyWrp.classList.add('show_msg_of_reply_wrp');
      showMsgOfReplyWrp.style.borderLeftColor = replyData.sender.colour;

      const showMsgOfReplyName = document.createElement("span");
      showMsgOfReplyName.classList.add('show_msg_of_reply_name');
      showMsgOfReplyName.style.color = replyData.sender.colour;
      showMsgOfReplyName.textContent = `${replyData.sender.first_name} ${replyData.sender.last_name}`;

      let showMsgOfReplyTxt = document.createElement("span");
      showMsgOfReplyTxt.classList.add('show_msg_of_reply_txt');
      if(replyData.reply_to_msg.forwarded){
        if(replyData.reply_to_msg.forwarded_from.file){
          const link = document.createElement('a');
          link.href = replyData.reply_to_msg.forwarded_from.file;
          link.target = '_new';
          link.textContent = this.getFileName(replyData.reply_to_msg.forwarded_from.file);
          showMsgOfReplyTxt.appendChild(link);
        }else{
          showMsgOfReplyTxt.textContent = replyData.reply_to_msg.forwarded_from.message;
        }
      }else{
        if(replyData.reply_to_msg.file){
          const link = document.createElement('a');
          link.href = replyData.reply_to_msg.file;
          link.target = '_new';
          link.textContent = this.getFileName(replyData.reply_to_msg.file);
          showMsgOfReplyTxt.appendChild(link);
        }else{
          showMsgOfReplyTxt.textContent = replyData.reply_to_msg.message;
        }
      }
      showMsgOfReplyWrp.appendChild(showMsgOfReplyName);
      showMsgOfReplyName.after(showMsgOfReplyTxt);
      return showMsgOfReplyWrp;
    },
    createMessageContentMethod(data) {
        const contentWrapper = document.createElement('span');
        // Helper function to create and append a link element
        const createLinkElement = (href, textContent) => {
          const link = document.createElement('a');
          link.href = href;
          link.target = '_new';
          link.classList.add('hyper_link');
          link.textContent = textContent;
          return link;
        };

        // Helper function to create and append a text span
        const createTextSpan = (message) => {
          const textSpan = document.createElement('span');
          textSpan.classList.add('msg_link');
          textSpan.innerHTML = message;
          return textSpan;
        };

        // Helper function to handle file rendering
        const renderFile = (fileUrl, messageContent) => {
          const msgExt = fileUrl.substring(fileUrl.lastIndexOf('.') + 1).split('?')[0];
          const link = createLinkElement(fileUrl, ''); // Link text will be the image/file
          const fileIcon = document.createElement('img');
          fileIcon.classList.add('img-fluid');

          if (['png', 'PNG', 'jpeg', 'jpg', 'svg', 'gif', 'webp'].includes(msgExt)) {
            fileIcon.src = fileUrl;
            const imgContainer = document.createElement('span');
            imgContainer.classList.add('msg_img_render_in_chat');
            imgContainer.appendChild(link);
            link.appendChild(fileIcon);
            contentWrapper.appendChild(imgContainer);
          } else {
            fileIcon.src = this.checkFileExtensionForChatMessage(fileUrl);
            const fileRenderContainer = document.createElement('span');
            fileRenderContainer.classList.add('msg_file_render_in_chat');
            fileRenderContainer.appendChild(link);
            link.appendChild(fileIcon);

            const fileNameSpan = document.createElement('span');
            fileNameSpan.classList.add('msg_file_name');
            fileNameSpan.textContent = fileUrl.split('/').pop().split('?')[0]; // Use pop() for last segment
            link.appendChild(fileNameSpan); // Append fileNameSpan to the link
            contentWrapper.classList.add('msg_in_file');
            contentWrapper.appendChild(fileRenderContainer);
          }

          // Append message content after the file/image, if it exists
          if (messageContent) {
            if (messageContent.startsWith('http://') || messageContent.startsWith('https://')) {
              contentWrapper.appendChild(createLinkElement(messageContent, messageContent));
            } else {
              contentWrapper.appendChild(createTextSpan(messageContent));
            }
          }
        };

        if (data.forwarded) {
          if (data.forwarded_from.file) {
            renderFile(data.forwarded_from.file, data.forwarded_from.message);
          } else if (data.forwarded_from.message) { // Only message, no file
            if (data.forwarded_from.message.startsWith('http://') || data.forwarded_from.message.startsWith('https://')) {
              contentWrapper.appendChild(createLinkElement(data.forwarded_from.message, data.forwarded_from.message));
            } else {
              contentWrapper.appendChild(createTextSpan(data.forwarded_from.message));
            }
          }
        } else if (data.file) {
          renderFile(data.file, data.message);
        } else if (data.message) { // Only message, no file and not forwarded
          if (data.message.startsWith('http://') || data.message.startsWith('https://')) {
            contentWrapper.appendChild(createLinkElement(data.message, data.message));
          } else {
            contentWrapper.appendChild(createTextSpan(data.message));
          }
        }

        return contentWrapper;
      },
    createMessageOptionsDropdownMethod(data, self) {
      const dropdownDiv = document.createElement("div");
      dropdownDiv.classList.add('dropdown');

      const msgToggleOption = document.createElement("span");
      msgToggleOption.classList.add('msg_toggle_option');
      msgToggleOption.setAttribute("data-toggle", 'dropdown');

      const faChevronDown = document.createElement("i");
      faChevronDown.classList.add('fa', 'fa-chevron-down');
      msgToggleOption.appendChild(faChevronDown);
      dropdownDiv.appendChild(msgToggleOption);

      const dropdownMenu = document.createElement("ul");
      dropdownMenu.classList.add('dropdown-menu');
      msgToggleOption.after(dropdownMenu);

      const replyLi = document.createElement("li");
      replyLi.textContent = 'Reply';
      replyLi.onclick = function () {
        self.replyMessageOnChatMethod(data);
      };
      dropdownMenu.appendChild(replyLi);

      const forwardedMessageLi = document.createElement("li");
      forwardedMessageLi.textContent = 'Forward Message';
      forwardedMessageLi.onclick = function () {
        self.forwardLiveMsgToUserMethod(data);
      };
      dropdownMenu.appendChild(forwardedMessageLi);

      const deleteLi = document.createElement("li");
      deleteLi.textContent = 'Delete Message';
      deleteLi.onclick = function () {
        self.deteteMessageFromChatMethod(data.id, data.message, data.timestamp, data.sender.user_id);
      };
      dropdownMenu.appendChild(deleteLi);

      return dropdownDiv;
    },

    createForwardCheckboxMethod(data, currentMessage, self) {
      const radioLabel = document.createElement('label');
      radioLabel.classList.add('live_msg_f_label');
      radioLabel.setAttribute('for', 'msg_input' + data.id);

      const customCheckboxSpan = document.createElement('span');
      customCheckboxSpan.classList.add('custom_checkbox_span');

      const customCheckboxI = document.createElement('i');
      customCheckboxI.classList.add('fa', 'fa-check');
      customCheckboxSpan.appendChild(customCheckboxI);

      const radioInput = document.createElement('input');
      radioInput.type = 'checkbox';
      radioInput.id = 'msg_input' + data.id;
      radioInput.hidden = true;
      radioInput.onclick = function () {
        self.forwardMsgCheckboxMethod(currentMessage, data.id);
      };

      radioLabel.appendChild(radioInput);
      radioLabel.appendChild(customCheckboxSpan);
      return radioLabel;
    },

    createReadStatusLabelMethod(data) {
      this.lastLiveMsgData = data;
      const labelReadS = document.createElement("label");
      labelReadS.classList.add('chat_msg_send_received_action_wrp');
      const labelReadI = document.createElement("i");
      labelReadI.classList.add('msg_indication');
      const liveMsgs = document.querySelectorAll('.live_msg .msg_indication');
      const apiMsgs = document.querySelectorAll('.chat_msg_li .msg_indication');
      if (this.getMessageStatusMethod(data.message_statuses) == 'read') {
        labelReadI.setAttribute("class", 'msg_indication msg_read_ind');
        // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          element.classList.remove('msg_sent_ind');
          element.classList.add('msg_read_ind'); // Replace 'your-new-class' with the class you want to add
        })
        apiMsgs.forEach(element => {
          element.classList.remove('msg_sent_ind');
          element.classList.add('msg_read_ind'); // Replace 'your-new-class' with the class you want to add
        })
      } else if (this.getMessageStatusMethod(data.message_statuses) == 'delivered') {
        labelReadI.setAttribute("class", 'msg_indication msg_sent_ind');
         // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          if (!element.classList.contains('msg_read_ind')) {
              element.classList.remove('msg_unsent_ind');
              element.classList.add('msg_sent_ind');
          } // Replace 'your-new-class' with the class you want to add
        })
         apiMsgs.forEach(element => {
          if (!element.classList.contains('msg_read_ind')) {
              element.classList.remove('msg_unsent_ind');
              element.classList.add('msg_sent_ind');
          } // Replace 'your-new-class' with the class you want to add
        })
      } else {
        labelReadI.setAttribute("class", 'msg_indication msg_unsent_ind')
      }
        labelReadS.appendChild(labelReadI);
        return labelReadS;
    },
    /*
     * This Will File Sent In Chat Method Here
     */
    onInputClick(event) {
      event.target.value = ''
    },

    handleFileUpload(event) {
      this.imgSrc = ''
      if (event.target.files && event.target.files.length > 0) {
        this.uploadFile = event.target.files[0];
        this.filename = this.uploadFile.name
        if (event.target.files[0].type.split('/')[0] == 'image') {
          if (typeof FileReader === 'function') {
            const reader = new FileReader();
            reader.onload = (event) => {
              this.imgSrc = event.target.result;
            };
            reader.readAsDataURL(this.uploadFile);
          } else {
            alert('Sorry, FileReader API not supported');
          }
        }
      }
    },

    textareaInputWithFileMethod(e) {
      document.querySelector('#textarea_for_file_input').addEventListener('keydown', event => {
        if (event.key === 'PageUp' || event.key === 'PageDown') {
          const cursorPosition = event.key === 'PageUp' ? 0 : event.target.textLength;
          event.preventDefault();
          event.target.setSelectionRange(cursorPosition, cursorPosition);
        }
      });
      if (this.fileMessage.length >= 1) {
        if (this.fileMessage.split('').slice(-1) == '@' || e.key == '@') {
          this.suggestionUserListStateForFileAttach = true;
        }
      } else {
        this.suggestionUserListStateForFileAttach = false;
      }
    },

    cancelUploadFile() {
      this.uploadFile = null;
      this.filename = '';
      this.fileMessage = '';
      this.messageContentDraftValue = '';
      document.querySelector('#chat-message-reply-input').value = '';
      this.listLoading = false;
      this.uploadProgress = 0;
      this.submitted = false;
    },

    /*
     * This Will Check File Extension In Chat
     */
    checkFileExtensionForChatMessage(file) {
      let extension = file.substr((file.lastIndexOf('.') + 1));
      extension = extension.substring(0, extension.lastIndexOf("?"));
      switch (extension) {
        case 'zip':
          return require('@/assets/images/filetype/zip.png');
          break;
        case 'rar':
          return require('@/assets/images/filetype/zip-1.png');
          break;
          break;
        case 'eps':
          return require('@/assets/images/filetype/ai.png');
          break;
        case 'pdf':
          return require('@/assets/images/filetype/pdf.png');
          break;
        case 'css':
          return require('@/assets/images/filetype/css.png');
          break;
        case 'csv':
          return require('@/assets/images/filetype/csv.png');
          break;
        case 'doc':
          return require('@/assets/images/filetype/doc.png');
          break;
        case 'docx':
          return require('@/assets/images/filetype/doc.png');
          break;
        case 'json':
          return require('@/assets/images/filetype/json-file.png');
          break;
        case 'ppt':
          return require('@/assets/images/filetype/ppt.png');
          break;
        case 'pptx':
          return require('@/assets/images/filetype/ppt.png');
          break;
        case 'txt':
          return require('@/assets/images/filetype/txt.png');
          break;
        case 'xls':
          return require('@/assets/images/filetype/xls.png');
          break;
        case 'xlsx':
          return require('@/assets/images/filetype/xls.png');
          break;
        case 'xml':
          return require('@/assets/images/filetype/xml.png');
          break;
        case 'xlsm':
          return require('@/assets/images/filetype/xls.png');
          break;
        case 'py':
          return require('@/assets/images/filetype/python.png');
        case 'cpp':
          return require('@/assets/images/filetype/cpp-file-format-symbol.png');
          break;
        case 'vbb':
          return require('@/assets/images/filetype/coding.png');
          break;
        default:
          return require('@/assets/images/filetype/d_file.png');
      }
    },

    /*
     * This Will Check File Extension In Chat
     */
    checkFileExtension(file) {
      let extension = file.substr((file.lastIndexOf('.') + 1));
      switch (extension) {
        case 'jpg':
          return require('@/assets/images/filetype/jpg.png');
          break;
        case 'jpeg':
          return require('@/assets/images/filetype/jpg.png');
          break;
        case 'png':
          return require('@/assets/images/filetype/png.png');
          break;
        case 'gif':
          return require('@/assets/images/filetype/jpg.png');
          break;
        case 'zip':
          return require('@/assets/images/filetype/zip.png');
          break;
        case 'rar':
          return require('@/assets/images/filetype/zip-1.png');
          break;
          break;
        case 'eps':
          return require('@/assets/images/filetype/ai.png');
          break;
        case 'pdf':
          return require('@/assets/images/filetype/pdf.png');
          break;
        case 'css':
          return require('@/assets/images/filetype/css.png');
          break;
        case 'csv':
          return require('@/assets/images/filetype/csv.png');
          break;
        case 'doc':
          return require('@/assets/images/filetype/doc.png');
          break;
        case 'docx':
          return require('@/assets/images/filetype/doc.png');
          break;
        case 'json':
          return require('@/assets/images/filetype/json-file.png');
          break;
        case 'ppt':
          return require('@/assets/images/filetype/ppt.png');
          break;
        case 'pptx':
          return require('@/assets/images/filetype/ppt.png');
          break;
        case 'txt':
          return require('@/assets/images/filetype/txt.png');
          break;
        case 'xls':
          return require('@/assets/images/filetype/xls.png');
          break;
        case 'xlsx':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'xml':
          return require('@/assets/images/filetype/xml.png');
          break;
        case 'xlsm':
          return require('@/assets/images/filetype/xls.png');
          break;
        case 'py':
          return require('@/assets/images/filetype/python.png');
        case 'cpp':
          return require('@/assets/images/filetype/cpp-file-format-symbol.png');
          break;
        case 'vbb':
          return require('@/assets/images/filetype/coding.png');
          break;
        default:
          return require('@/assets/images/filetype/d_file.png');
      }
    },

    /*
     * This Will Check File Submitted In MSG Method Here
     */
    fileMsgSubmitMethod() {
      this.submitted = true
      let formData = new FormData();

      formData.append('chat_room_user', this.selectedRoomInfo.chat_room);
      formData.append('message', this.fileMessage);
      formData.append('file', this.uploadFile);
      formData.append('filename', this.filename);
      
      this.listLoading = true;

      axios.post(UploadMsgFileURL, formData, {
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
        },
      }).then((res) => {
        const messageId = res.data.data.id;
        this.chatSocketMethod.send(JSON.stringify({
          type: 'file_upload',
          message_id:messageId
        }));
        const payload = {
          chatRoomId: this.selectedRoomInfo.chat_room
        };
        bus.$emit('newChatMessage', payload);
        this.cancelUploadFile();
      }).catch((err) => {
        toast.error(err.data.msg);
        this.listLoading = false;
        this.uploadProgress = 0;
        this.submitted = false;
      })
    },
    
    fileOpenNewTab(href) {
      window.open(href, '_blank');
    },
    /*
     * This Will Check Blocked User Method Here
     */
    replaceURLsInMsgText(message) {
      if (!message) return;
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return message.replace(urlRegex, function (url) {
        var hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
          hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" class="hyper_link" target="_blank">' + url + '</a>'
      });
    }
  },
  watch: {
    getSelectedChatRoomInfo(newVal, oldVal) {
      this.selectedRoomInfo = newVal;
      if (!this.selectedRoomInfo) return;
      this.multiMessageOptionEnabled = false;
      this.multipleMessageArr = [];
      this.buildChatRoomMethod(newVal);
    },
    getSelfUserInfo() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
    welcomeBlurbInfo(newVal, oldVal) {
      if (newVal) {
        this.welcomeBlurbsPopupState = true
      }
    }
  },
}